/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

export default {
	COMPLETED: 'Smarts-IFR-20',
	UNSUPPORTED_UNENRICHED_PACKAGE: 'Smarts-IFR-21',
	INVALID_SMARTSMODULE_URI: 'Smarts-IFR-40',
	INVALID_SMARTSMODULE_JSON: 'Smarts-IFR-41',
	INVALID_ANALYSIS_SCOPE_TABLE: 'Smarts-IFR-42',
	INVALID_ANALYSIS_SCOPE_FIELD: 'Smarts-IFR-43',
	INVALID_TARGET_FIELD:'Smarts-IFR-44',
	INVALID_MISSING_SMARTSMODULE:'Smarts-IFR-45',
	INVALID_REQUESTCONTEXT: 'Smarts-IFR-46',
	INVALID_REQUEST: 'Smarts-IFR-47',
	INVALID_MODULE_ID: 'Smarts-IFR-48',
	UNSUPPORTED_MODULE_TYPE: 'Smarts-IFR-49',
	INTERNAL_ERROR: 'Smarts-IFR-50',
	INTERNAL_INVALID_ONTOLOGY_DOMAIN:'Smarts-IFR-51',
	INTERNAL_INVALID_FIELD_STATS:'Smarts-IFR-52',
	INTERNAL_INVALID_SAMPLE_STATS: 'Smarts-IFR-53',
	//Generic errors
	RELATIONSHIP_REQUEST_TIMEOUT:'timeout',
	NOT_JOINED_ERROR: 'XQE-MSR-0008'
};



// WEBPACK FOOTER //
// ./src/js/util/SmartsRecommenderStatus.js